import React, { ReactElement } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../store/store';
import { isPartnersDashboard } from '../../../utils/scopeLimit';
import BillingAddress from '../../Modals/BillingAddressModal/BillingAddressModal';
import BlockingModal from '../../Modals/BlockingModal/BlockingModal';
import HowItWorksModal from '../../Modals/HowItWorksModal/HowItWorksModal';
import OffboardingModal from '../../Modals/OffboardingModal/OffboardingModal';
import OnboardingModal from '../../Modals/OnboardingModal/OnboardingModal';
import PlanSelectionModal from '../../Modals/PlanSelectionModal/PlanSelectionModal';
import PlansModal from '../../Modals/PlansModal/PlansModal';
import ServiceUpdateModal from '../../Modals/ServiceUpdateModal/ServiceUpdateModal';
import SpeedLimitModal from '../../Modals/SpeedLimitModal/SpeedLimitModal';
import TimezoneModal from '../../Modals/TimezoneModal/TimezoneModal';
import TopUpModal from '../../Modals/TopUpModal/TopUpModal';
import CancelSessionModal from '../../Modals/CancelSessionModal/CancelSessionModal';
import RatingModal from '../../Modals/RatingModal/RatingModal';
import UpsellPlansModal from '../../Modals/UpsellPlansModal/UpsellPlansModal';
import SunsetPaywallModal from '../../Modals/SunsetPaywallModal/SunsetPaywallModal';
import StudioMigrationModal from '../../Modals/StudioMigrationModal/StudioMigrationModal';

const ModalsContainer = (): ReactElement => {
  const {
    isShowBillingModal,
    isShowSpeedLimitModal,
    isShowTimezoneModal,
    isShowOffboardingModal,
    isShowOnboardingModal,
    isShowHowItWorksModal,
    isShowBlockingModal,
    isShowServiceUpdateModal,
    isShowBillingAddressModal,
    isShowRatingModal,
    isShowTopUpModal,
    isShowCancelSessionModal,
    isShowPlansModal,
    isUpsellPlansModal,
    isShowStudioMigrationModal,
    isShowSunsetOndemandModal
  } = useSelector((state: RootState) => state.modalsSlice, shallowEqual);

  const { studioSunsetPaywall } = useFlags();
  // Sunset modals are for users only, never the musicians (partners) dashboard.
  const showSunsetModals = studioSunsetPaywall && !isPartnersDashboard();

  return (
    <>
      <PlanSelectionModal isOpen={isShowBillingModal} />
      <SpeedLimitModal isOpen={isShowSpeedLimitModal} />
      <TimezoneModal isOpen={isShowTimezoneModal} />
      <OffboardingModal isOpen={isShowOffboardingModal} />
      <OnboardingModal isOpen={isShowOnboardingModal} />
      <BlockingModal isOpen={isShowBlockingModal} />
      <HowItWorksModal isOpen={isShowHowItWorksModal} />
      <ServiceUpdateModal isOpen={isShowServiceUpdateModal} />
      {showSunsetModals ? (
        <>
          <SunsetPaywallModal
            isOpen={isShowTopUpModal.isShown || isUpsellPlansModal || isShowSunsetOndemandModal}
          />
          <StudioMigrationModal isOpen={isShowStudioMigrationModal} />
        </>
      ) : (
        <>
          <TopUpModal isOpen={isShowTopUpModal.isShown} />
          <UpsellPlansModal isOpen={isUpsellPlansModal} />
        </>
      )}
      <CancelSessionModal isOpen={isShowCancelSessionModal.isShown} />
      <PlansModal isOpen={isShowPlansModal} />
      <BillingAddress isOpen={isShowBillingAddressModal} />
      <RatingModal isOpen={isShowRatingModal.isShown} />
    </>
  );
};

export default ModalsContainer;
